import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LineChartComponent } from './line-chart/line-chart.component';
import { HeatmapComponent } from './heatmap/heatmap.component';
import { BoxChartComponent } from './box-chart/box-chart.component';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { ChartsCommonFunctions } from './chartsCommonFunctions';
import { RetailerProfileComponent } from 'src/app/profiles/retailer-profile/retailer-profile.component';
import { ListProfileComponent } from 'src/app/profiles/list-profile/list-profile.component';
import { PlotlyModule } from 'angular-plotly.js';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { LoaderComponent } from '../loader/loader.component';
import { FormsModule } from '@angular/forms';
import {MatTabsModule} from '@angular/material/tabs';
import { MetricTableComponent } from './metric-table/metric-table.component';
import { ProductListComponent } from './product-list/product-list.component';
import { SingleBarChartComponent } from './single-bar-chart/single-bar-chart.component';
import { ComparedBarChartComponent } from './compared-bar-chart/compared-bar-chart.component';
import { ProfileTopMatterComponent } from 'src/app/profiles/profile-top-matter/profile-top-matter.component';

@NgModule({
  declarations: [
  
  


  ],
  imports: [
    CommonModule,
    PlotlyModule,
    MatTooltipModule,
    ShareButtonsModule,
    FormsModule,
    MatTabsModule,

  ],
  providers: [
    ChartsCommonFunctions,
    RetailerProfileComponent,
    ListProfileComponent,
    ProfileTopMatterComponent,
    LineChartComponent,
    HeatmapComponent,
    BoxChartComponent,
    BarChartComponent,
    PieChartComponent,
    LoaderComponent,
    MetricTableComponent,
    ProductListComponent,
    SingleBarChartComponent,
    ComparedBarChartComponent,

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChartsModule {}
